import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LoginPage from "../pages/login/page";
import DashboardPage from "../pages/dashboard/page";
import ClientesPage from "../pages/dashboard/clientes/page";
import ClienteDetailPage from "../pages/dashboard/clientes/detail/page";
import CatalogoPage from "../pages/dashboard/catalogo/page";
import ContabilidadPage from "../pages/dashboard/contabilidad/page";
import ConfiguracionPage from "../pages/dashboard/configuracion/page";
import NominasPage from "../pages/dashboard/nominas/page";
import TrabajadoresPage from "../pages/dashboard/trabajadores/page";
import ProveedoresPage from "../pages/dashboard/proveedores/page";
import UsuariosPage from "../pages/dashboard/usuarios/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";
import NuevaCotizacionPage from "../pages/dashboard/cotizaciones/page";
const routes: RouteObject[] = [
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/clientes",
    element: (
      <ProtectedRoute>
        <ClientesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/clientes/:id",
    element: (
      <ProtectedRoute>
        <ClienteDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/catalogo",
    element: (
      <ProtectedRoute>
        <CatalogoPage />
      </ProtectedRoute>
    ),
  },
    {
    path: "/dashboard/contabilidad",
    element: (
      <ProtectedRoute>
        <ContabilidadPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/nominas",
    element: (
      <ProtectedRoute>
        <NominasPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard/trabajadores",
    element: (
      <ProtectedRoute roles={['admin', 'contabilidad']}>
        <TrabajadoresPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/proveedores",
    element: (
      <ProtectedRoute roles={['admin', 'contabilidad']}>
        <ProveedoresPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/usuarios",
    element: (
      <ProtectedRoute roles={['admin']}>
        <UsuariosPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/configuracion",
    element: (
      <ProtectedRoute roles={['admin']}>
      <ConfiguracionPage />
      </ProtectedRoute>
    ),
  },
  {
   path:"/dashboard/cotizaciones/nueva", 
   element: <NuevaCotizacionPage/>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;